"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PixiHyperSpinShower = void 0;
var _pixi = require("pixi.js");
var particles = _interopRequireWildcard(require("pixi-particles"));
var _core = require("@dragon/core");
var _pixiGame = require("@dragon/pixi-game");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PixiHyperSpinShower = exports.PixiHyperSpinShower = /*#__PURE__*/function (_PixiGameComponent) {
  /**
   * Note that the default texture is dependent on the asset in core lib shared folder.
   * 
   * @param config 
   * @param texture 
   */
  function PixiHyperSpinShower(config) {
    var _this;
    var texture = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'assets/shared/hs_star.png';
    _classCallCheck(this, PixiHyperSpinShower);
    _this = _callSuper(this, PixiHyperSpinShower, ["HyperSpinShower"]);
    _defineProperty(_this, "pContainer", void 0);
    _defineProperty(_this, "config", {
      "alpha": {
        "start": 1,
        "end": 0.5
      },
      "scale": {
        "start": 1.5,
        "end": 1,
        "minimumScaleMultiplier": 1
      },
      "speed": {
        "start": 150,
        "end": 50,
        "minimumSpeedMultiplier": 1
      },
      "acceleration": {
        "x": 0,
        "y": 0
      },
      "maxSpeed": 0,
      "startRotation": {
        "min": 0,
        "max": 360
      },
      "noRotation": false,
      "rotationSpeed": {
        "min": 50,
        "max": 100
      },
      "lifetime": {
        "min": 0.9,
        "max": 1.2
      },
      "blendMode": "normal",
      "frequency": 0.1,
      "emitterLifetime": -1,
      "maxParticles": 150,
      "pos": {
        "x": 0,
        "y": 0
      },
      "addAtBack": false,
      "spawnType": "burst",
      "particlesPerWave": 4,
      "particleSpacing": 0,
      "angleStart": 10
    });
    _defineProperty(_this, "_emitter", void 0);
    _defineProperty(_this, "_numberOfSymbols", void 0);
    _defineProperty(_this, "_elapsed", void 0);
    _defineProperty(_this, "_hasStarted", void 0);
    _defineProperty(_this, "_tickerUpdateBind", void 0);
    _defineProperty(_this, "desktopPos", {
      x: 1622,
      y: 970
    });
    _defineProperty(_this, "_disabled", void 0);
    _defineProperty(_this, "start", function () {
      if (_this._disabled) return;
      _this.refreshLocation(_core.CORE.getState().config.screenSize);
      _this._elapsed = Date.now();
      _this._emitter.emit = true;
      _this._hasStarted = true;
      _this.application.ticker.add(_this._tickerUpdateBind);
    });
    _defineProperty(_this, "stop", function () {
      _this._hasStarted = false;
      _this._emitter.emit = false;
    });
    if (config) {
      _this.config = Object.assign(_this.config, config);
    }
    _this.pContainer = new _pixi.ParticleContainer();
    _this.pContainer.y = 10;
    //  this.config.color = element;
    var em = new particles.Emitter(_this.pContainer, [_pixi.Texture.from(texture)], _this.config);
    _this.addChild(_this.pContainer);
    em.emit = false;
    _this._emitter = em;
    _this._elapsed = Date.now();
    _this._tickerUpdateBind = _this.update.bind(_this);
    _core.CORE.subscribe('game.hyperSpin', function (e) {
      if (e) _this.start();else _this.stop();
    });

    // TODO make it look nicer, until then lets skip for desktop
    if (_core.CORE.getState().config.channel == _core.Channel.Desktop) _this._disabled = true;
    return _this;
  }
  _inherits(PixiHyperSpinShower, _PixiGameComponent);
  return _createClass(PixiHyperSpinShower, [{
    key: "refreshLocation",
    value: function refreshLocation(s) {
      this.scale.set(s.scaleFactorHd);
      if (s.channel == _core.Channel.Desktop) {
        this.position.set(this.desktopPos.x * s.scaleFactorHd, this.desktopPos.y * s.scaleFactorHd);
      } else {
        var spinButt = document.getElementsByClassName("spinButtonLocateHelper")[0];
        if (spinButt) {
          var location = spinButt.getBoundingClientRect();
          if (location) {
            this.x = location.x + location.width / 2;
            this.y = location.y + location.height / 2;
          }
        } else {
          _core.L.warn("HyperSpin, no spin button found");
        }
      }
    }
  }, {
    key: "onResize",
    value: function onResize(s) {
      this.refreshLocation(s);
    }
  }, {
    key: "update",
    value: function update() {
      var now = Date.now();
      this._emitter.update((now - this._elapsed) * 0.0007);
      this._elapsed = now;
      if (this._emitter.particleCount == 0 && !this._hasStarted) {
        this.application.ticker.remove(this._tickerUpdateBind);
      }
      ;
    }
  }]);
}(_pixiGame.PixiGameComponent);
//# sourceMappingURL=PixiHyperSpinShower.js.map